var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextField',{attrs:{"fieldName":"Notes","placeholderText":"Add notes (optional)","displayLabel":false,"textAreaInput":true,"value":_vm.value},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }